export enum WorkType {
  PP1 = 'pp1',
  PP2 = 'pp2',
  NP = 'np',
  NPSK = 'npsk',
}
